import React from "react";

export default function Ccard() {
  return (
    <div className="communication-card">
      <div className="card-header">
        <div className="office-name">
          Abdullah bin Nasser bin Hamad Al Ateeq Office for Services
        </div>
      </div>

      <div className="button-group">
        <a href="https://wa.me/+966504920299" className="btn whatsapp" target="_blank" rel="noopener noreferrer">
          WhatsApp <i className="fa fa-whatsapp" />
        </a>
        <a href="tel:+966504920299" className="btn call">
          communication <i className="fa fa-phone" />
        </a>
      </div>
    </div>
  );
}
